/*
 * ALCHEMY: interactions for the ingredient carousel (sections/carousel.liquid, opt-in).
 *  - Benefit filter chips: matching cards move to the front, the rest dim. "All" restores the order.
 *  - Counter + progress line that follow the swiper.
 * Nothing here touches the buy path; cards and the section button stay as they are.
 */
(() => {
  const ROOT = '.section-carousel--interactive';
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = (n) => String(n).padStart(2, '0');

  function setup(root) {
    if (!root || root.dataset.ingredientReady) return;
    const el = root.querySelector('swiper-component');
    const wrapper = el && el.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    root.dataset.ingredientReady = 'true';

    const slides = [...wrapper.querySelectorAll(':scope > .swiper-slide')]; // the wrapper also holds per-card <style> tags
    slides.forEach((slide, i) => (slide.dataset.order = i));
    const total = slides.length;

    const counter = root.querySelector('[data-carousel-counter]');
    const bar = root.querySelector('[data-carousel-progress]');
    const chips = [...root.querySelectorAll('.carousel-filters__chip')];

    const whenReady = (cb, tries = 0) => {
      if (el.swiper) return cb(el.swiper);
      if (tries < 100) setTimeout(() => whenReady(cb, tries + 1), 150);
    };

    whenReady((sw) => {
      const sync = () => {
        const visible = sw.slidesPerViewDynamic ? Math.ceil(sw.slidesPerViewDynamic()) : 1;
        const end = sw.isEnd ? total : Math.min(total, sw.activeIndex + visible);
        if (counter) counter.textContent = `${pad(end)} / ${pad(total)}`;
        if (bar) bar.style.transform = `scaleX(${end / total})`;
      };
      sw.on('slideChange', sync);
      sw.on('resize', sync);
      sw.on('breakpoint', sync);
      sync();

      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const filter = chip.dataset.filter;
          chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));

          const matches = (slide) =>
            filter === 'all' ||
            (slide.dataset.benefits || '')
              .split(',')
              .map((t) => t.trim())
              .includes(filter);

          const ordered = [...slides].sort(
            (a, b) => Number(matches(b)) - Number(matches(a)) || a.dataset.order - b.dataset.order
          );
          ordered.forEach((slide) => {
            wrapper.appendChild(slide);
            slide.classList.toggle('is-dimmed', filter !== 'all' && !matches(slide));
          });

          sw.update();
          sw.slideTo(0, reduceMotion() ? 0 : 500);
          sync();
        });
      });
    });
  }

  const init = () => document.querySelectorAll(ROOT).forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
